import { COGNITO_GROUPS, TEAMS } from 'utils/const';
import { loggedInSuccessfully } from './features/app/app.slice';
import {
  iAmAdmin,
  iAmIncentivesMember,
  iAmProductPlanningMember,
  iAmRecallComplianceMember,
} from './features/filePermissions/filePermissions.slice';

// on user login, set the file access permissions
export const filePermissionsMiddleware = (store) => (next) => (action) => {
  if (action.type === loggedInSuccessfully.type) {
    const cognitoUser = action.payload;
    const myTeam = cognitoUser.attributes['custom:team'];
    const cognitoGroups =
      cognitoUser.signInUserSession.accessToken.payload['cognito:groups'] || [];

    if (cognitoGroups.includes(COGNITO_GROUPS.ADMINS)) {
      store.dispatch(iAmAdmin());
      return next(action);
    }
    switch (myTeam) {
      case TEAMS.ADMIN:
        store.dispatch(iAmAdmin());
        break;
      case TEAMS.INCENTIVES:
        store.dispatch(iAmIncentivesMember(cognitoGroups));
        break;
      case TEAMS.PRODUCT_PLANNING:
        store.dispatch(iAmProductPlanningMember(cognitoGroups));
        break;
      case TEAMS.RECALL_COMPLIANCE:
        store.dispatch(iAmRecallComplianceMember(cognitoGroups));
        break;
      default:
        break;
    }
  }

  return next(action);
};
